module.exports = __webpack_public_path__ + "img/icon_time.9aece058.svg";